// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { spacing, mediaMax } from 'presentations/views/styles';
import SocialLoginButtonList from 'presentations/views/components/organisms/SocialLoginButtonList';
import PasswordLoginForm from 'presentations/views/components/organisms/PasswordLoginForm';
import Headline from 'presentations/views/components/atoms/Headline';
import { ErrorList } from 'domains/models';
import { Provider } from 'domains/models/account/providerType';
import Link from '../../atoms/Link';
import Button from '../../atoms/Button';
import { SyntheticEvent, useState } from 'react';

interface ServerProps {
  isLoading?: boolean;
  isResetLoading?: boolean;
  email: string | null;
  password: string | null;
  providers: string[] | null;
  onSubmit: any;
  onChange: any;
  onClickService: any;
  loadingProvider?: Provider | null;
  errors: ErrorList;
  onClickResetPassword?: any;
}

export default function Component(props: ServerProps) {
  const t = translateInComponent(translations);
  const [isResetPassword, setIsResetPassword] = useState<boolean>(false);
  function onClickForgotPassword(e: SyntheticEvent<HTMLLinkElement>) {
    e.preventDefault();
    setIsResetPassword(true);
  }

  const hasSocialLoginProvider = props.providers?.find(
    (provider) => provider !== Provider.Password,
  )
    ? true
    : false;

  return (
    <Container>
      <HeadlineContainer>
        <Headline variant="h2">{t('headline')}</Headline>
      </HeadlineContainer>
      <Description>
        <Text>{t('login description')}</Text>
      </Description>
      <Email>{props.email}</Email>
      <SocialButtonContainer>
        <SocialLoginButtonList
          isLoading={props.isLoading}
          loadingProvider={props.loadingProvider}
          isLogin={true}
          providers={props.providers}
          onClickService={props.onClickService}
        />
      </SocialButtonContainer>
      {(!props.providers || props.providers.includes(Provider.Password)) && (
        <PasswordFormContainer>
          <PasswordLoginForm
            hasSocialLoginProvider={hasSocialLoginProvider}
            isLoading={props.isLoading}
            isLogin={true}
            email={props.email}
            password={props.password}
            onSubmit={props.onSubmit}
            onChange={props.onChange}
            errors={props.errors}
          />
          <AuthDescription>
            {isResetPassword ? (
              <Button
                isLoading={props.isResetLoading}
                color="primary"
                onClick={props.onClickResetPassword}
              >
                {t('Send reset link')}
              </Button>
            ) : (
              <LinkText onClick={onClickForgotPassword}>
                {t('Forgot password')}
              </LinkText>
            )}
          </AuthDescription>
        </PasswordFormContainer>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HeadlineContainer = styled.div`
  margin-top: ${spacing(88)};
  margin-bottom: ${spacing(32)};
  ${mediaMax.tablet} {
    margin-top: ${spacing(48)};
  }
`;
const Description = styled.div`
  margin-bottom: ${spacing(24)};
`;
const Text = styled.span``;
const LinkText = styled(Link)``;
const Email = styled.div`
  margin-bottom: ${spacing(24)};
`;

const SocialButtonContainer = styled.div`
  margin-bottom: ${spacing(24)};
`;
const PasswordFormContainer = styled.div`
  margin-bottom: ${spacing(24)};
`;

const AuthDescription = styled.div`
  text-align: center;
  margin-top: ${spacing(24)};
`;
